import React from 'react'

const Haqt404Page = () => {
  return (
    <div>404 Page not found</div>
  );
};

export default Haqt404Page;